import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { useFetch } from "../../lib/useFetch";
import { useAntiBot, useSeo } from "../../lib/hooks";
import { api, errMsg } from "../../lib/api";
import { PageHero } from "../../components/site/SiteLayout";
import { Field, inputCls, btnPrimary, btnOutline } from "../../components/site/ui";

export function Newsletter() {
  useSeo("Newsletter", "Iscriviti alla newsletter dello Studio Diolosa – Commercialisti.");
  const c = useFetch("/public/newsletter/consent").data;
  const ab = useAntiBot();
  const [email, setEmail] = useState("");
  const [interests, setInterests] = useState([]);
  const [consent, setConsent] = useState(false);
  const [msg, setMsg] = useState("");
  const [err, setErr] = useState("");
  const submit = async (e) => {
    e.preventDefault(); setErr("");
    try { const { data } = await api.post("/public/newsletter/subscribe", { email, interests, consent, ...(await ab.payload()) }); setMsg(data.message); }
    catch (x) { setErr(errMsg(x)); }
  };
  return (
    <>
      <PageHero eyebrow="Newsletter" title="Ricevi gli aggiornamenti dello studio">Iscrizione con doppia conferma via email. Nessun tracciamento di aperture o clic.</PageHero>
      <section className="section container-x max-w-2xl">
        {msg ? <p role="status" className="card-line p-6" data-testid="newsletter-success">{msg}</p> : (
          <form onSubmit={submit} className="card-line p-6 sm:p-8 space-y-5 relative">
            {ab.field}
            <Field id="nl-email" label="Email" required><input id="nl-email" type="email" className={inputCls} value={email} onChange={(e) => setEmail(e.target.value)} autoComplete="email" data-testid="newsletter-email-input" /></Field>
            {c?.interests?.length > 0 && <fieldset><legend className="text-sm font-medium mb-2">Argomenti di interesse</legend><div className="grid sm:grid-cols-2 gap-2">
              {c.interests.map((i) => <label key={i} className="flex items-center gap-2 tap"><input type="checkbox" className="h-5 w-5" checked={interests.includes(i)} onChange={(e) => setInterests(e.target.checked ? [...interests, i] : interests.filter((x) => x !== i))} />{i}</label>)}
            </div></fieldset>}
            <label className="flex items-start gap-3 text-sm"><input type="checkbox" className="h-5 w-5 mt-0.5" checked={consent} onChange={(e) => setConsent(e.target.checked)} data-testid="newsletter-consent-checkbox" /><span>{c?.text} <span className="text-xs text-muted-foreground">(versione {c?.version})</span></span></label>
            {err && <p role="alert" className="text-sm text-destructive">{err}</p>}
            <button className={btnPrimary} data-testid="newsletter-submit-btn">Iscriviti</button>
          </form>
        )}
      </section>
    </>
  );
}

export function NewsletterConfirm() {
  useSeo("Conferma iscrizione", "", true);
  const [sp] = useSearchParams();
  const [state, setState] = useState({ loading: true });
  useEffect(() => {
    api.post("/public/newsletter/confirm", { token: sp.get("token") })
      .then((r) => setState({ ok: true, manage: r.data.manage_token })).catch((e) => setState({ err: errMsg(e) }));
  }, [sp]);
  return (
    <section className="section container-x max-w-xl" data-testid="newsletter-confirm-page">
      <h1 className="text-4xl font-semibold">Conferma iscrizione</h1>
      {state.loading && <p className="mt-4">Verifica in corso…</p>}
      {state.ok && <p role="status" className="mt-4" data-testid="newsletter-confirmed">Iscrizione confermata. Grazie! Puoi <a className="underline" href={`/newsletter/gestisci?token=${state.manage}`}>gestire le preferenze</a> in qualsiasi momento.</p>}
      {state.err && <p role="alert" className="mt-4 text-destructive">{state.err}</p>}
    </section>
  );
}

export function NewsletterManage() {
  useSeo("Gestisci newsletter", "", true);
  const [sp] = useSearchParams();
  const token = sp.get("token") || "";
  const { data, error, reload } = useFetch(`/public/newsletter/manage?token=${encodeURIComponent(token)}`);
  const all = useFetch("/public/newsletter/consent").data?.interests || [];
  const [sel, setSel] = useState(null);
  const [msg, setMsg] = useState("");
  const interests = sel ?? data?.interests ?? [];
  const send = async (body) => { try { await api.post("/public/newsletter/manage", { token, ...body }); setMsg(body.unsubscribe ? "Disiscrizione completata. Non riceverai più la newsletter." : "Preferenze aggiornate."); reload(); } catch (e) { setMsg(errMsg(e)); } };
  return (
    <section className="section container-x max-w-xl">
      <h1 className="text-4xl font-semibold">Preferenze newsletter</h1>
      {error && <p role="alert" className="mt-4 text-destructive">{error}</p>}
      {data && <div className="mt-6 card-line p-6 space-y-4">
        <p>Indirizzo: <strong>{data.email}</strong> · Stato: <span data-testid="newsletter-status">{data.status === "confirmed" ? "iscritto" : data.status === "unsubscribed" ? "disiscritto" : data.status}</span></p>
        {all.map((i) => <label key={i} className="flex items-center gap-2"><input type="checkbox" className="h-5 w-5" checked={interests.includes(i)} onChange={(e) => setSel(e.target.checked ? [...interests, i] : interests.filter((x) => x !== i))} />{i}</label>)}
        <div className="flex flex-wrap gap-3">
          <button className={btnOutline} onClick={() => send({ interests })}>Salva preferenze</button>
          {data.status !== "unsubscribed" && <button className={btnPrimary} onClick={() => send({ unsubscribe: true })} data-testid="newsletter-unsubscribe-btn">Disiscriviti da tutte le newsletter</button>}
        </div>
        {msg && <p role="status" data-testid="newsletter-manage-msg">{msg}</p>}
      </div>}
    </section>
  );
}
